<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="75%">
      <v-card>
        <div class="pos-abs-fixed">
          <v-toolbar 
            dense 
            color="grey lighten-2"
          >
            <v-toolbar-title class="title">Novo Layout Sql</v-toolbar-title>
            <v-divider
              class="mx-2"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn flat fab small icon @click="$emit('input')" slot="activator">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                color="primary"
                fab
                dark
                small
                @click="adiciona"
                :loading="loading"
                slot="activator"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <span>Salvar</span>
            </v-tooltip>
          </v-toolbar>
        </div>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field 
                v-model="newLayoutSql.Descricao" 
                label="Descrição do layout sql"
                @keyup.enter="adiciona"
                autofocus
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field 
                v-model="newLayoutSql.Titulo" 
                label="Título"
                @keyup.enter="adiciona"
                autofocus
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-3>
              <v-autocomplete
                v-model="newLayoutSql.RecursoSistema"
                :items="recursosSistemaAtivo"
                item-text="Descricao"
                return-object
                menu-props="auto"
                label="Recurso Sistema"
                hide-details
                class="mb-3"
                no-data-text="Registro não encontrado."
                auto-select-first
                outline
                @change="changeRecursoSistema"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md6 pl-3>
              <v-autocomplete
                v-model="newLayoutSql.DescricaoSql"
                :items="sqlsAtivo"
                item-text="Descricao"
                return-object
                menu-props="auto"
                label="Sql"
                hide-details
                class="mb-3"
                no-data-text="Registro não encontrado."
                auto-select-first
                outline
                @change="changeSql"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import LayoutSql from '@/domain/layoutSql/LayoutSql';

export default {
  name: 'ModalCadastroLayoutSql',
  props: ['value'],
  data() {
    return {
      loading: false,
      newLayoutSql: new LayoutSql(),
    }
  },
  computed: {
    ...mapGetters([
      'sqlsAtivo', 
      'recursosSistemaAtivo',
    ]),
  },
  methods: {
    ...mapActions(['addLayoutSql']),
    ...mapMutations(['showNotification', 'closeNotification']),
    changeSql(obj) {
      this.newLayoutSql.IdSql = obj.IdSql;
      this.newLayoutSql.DescricaoSql = obj.Descricao;
      this.newLayoutSql.InstrucaoSql = obj.InstrucaoSql;
    },
    changeRecursoSistema(obj) {
      this.newLayoutSql.IdRecursoSistema = obj.IdRecursoSistema;
      this.newLayoutSql.RecursoSistema = obj.Descricao;
    },
    validaFormularioLayoutSql() {
      return this.newLayoutSql && this.newLayoutSql.Descricao && this.newLayoutSql.IdRecursoSistema;
    },
    async adiciona() {
      if (this.validaFormularioLayoutSql()) {
        this.loading = true;
        try {
          const layoutSqlSalvo = await this.addLayoutSql(this.newLayoutSql);
          this.showNotification({ text: `Layout Sql: ${this.newLayoutSql.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.newLayoutSql = new LayoutSql();
          this.$emit('input');
          this.$emit('layoutSalvo', layoutSqlSalvo);
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o layout sql: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição o Recurso Sistema e o Sql do layout sql.`, status: 'error' });
      }
    }
  }
}
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 1;
  position: relative;
  padding-bottom: 50px;
}

.pos-abs-fixed > :first-child {
  position: fixed;
  max-width: 74.4%;
}
</style>
